const MONTHS_NOM = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
const MONTHS_GEN = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

/**
 * The club lives on Moscow time (sales window, lesson months, access «until the 6th»). Every date shown or
 * grouped here is read in Europe/Moscow, whatever the phone's own time zone is — the same as the server.
 */
const MSK = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Moscow', year: 'numeric', month: 'numeric', day: 'numeric' });
export function msk(d: Date): { y: number; m: number; d: number } {
  const parts = MSK.formatToParts(d);
  const get = (t: string) => Number(parts.find((p) => p.type === t)?.value ?? 0);
  return { y: get('year'), m: get('month') - 1, d: get('day') };
}

export const monthName = (d: Date) => MONTHS_NOM[msk(d).m]!;
export const monthKey = (d: Date) => {
  const p = msk(d);
  return `${p.y}-${String(p.m + 1).padStart(2, '0')}`;
};
export const monthTitle = (key: string) => {
  const [y, m] = key.split('-').map(Number) as [number, number];
  return msk(new Date()).y === y ? MONTHS_NOM[m - 1]! : `${MONTHS_NOM[m - 1]} ${y}`;
};
export const dayMonth = (iso: string) => {
  const p = msk(new Date(iso));
  return `${p.d} ${MONTHS_GEN[p.m]}`;
};
export const dateDots = (iso: string) => {
  const p = msk(new Date(iso));
  return `${String(p.d).padStart(2, '0')}.${String(p.m + 1).padStart(2, '0')}.${p.y}`;
};
export const plural = (n: number, one: string, few: string, many: string) => {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return `${n} ${one}`;
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return `${n} ${few}`;
  return `${n} ${many}`;
};
export const imageSrc = (name: string | null | undefined): string | null => {
  if (!name) return null;
  if (/^https?:\/\//i.test(name) || name.startsWith('/')) return name;
  return `/files/${name}`;
};
/** «ноября» for «Твоя программа ноября» */
export const monthGenitive = (key: string) => MONTHS_GEN[(Number(key.split('-')[1]) || 1) - 1]!;
/** «Ноябрь 2026» — always with the year (archive rows, breadcrumbs) */
export const monthLong = (key: string) => {
  const [y, m] = key.split('-').map(Number) as [number, number];
  return `${MONTHS_NOM[m - 1]} ${y}`;
};
/** Lessons of one month in publishing order (first published = «Урок 1»). */
export const byDate = <T extends { createdAt: string }>(list: T[]) => [...list].sort((a, b) => (a.createdAt < b.createdAt ? -1 : a.createdAt > b.createdAt ? 1 : 0));
